export var E_ROUTE_NAME;
(function (E_ROUTE_NAME) {
    E_ROUTE_NAME["FORGET_PASSWORD_SMS"] = "ForgetPasswordSms";
    E_ROUTE_NAME["FORGET_PASSWORD_EMAIL"] = "ForgetPasswordEmail";
    E_ROUTE_NAME["REGISTER"] = "Register";
    E_ROUTE_NAME["REGISTER_INVITE"] = "RegisterInvite";
    E_ROUTE_NAME["REGISTER_TRIAL"] = "RegisterTrial";
    E_ROUTE_NAME["REGISTER_TRIAL_EMBED"] = "RegisterTrialEmbed";
    E_ROUTE_NAME["REGISTER_FOR_FREE"] = "RegisterForFree";
    E_ROUTE_NAME["ACTIVE"] = "ACTIVE";
    E_ROUTE_NAME["ACTIVATION"] = "Activation";
    E_ROUTE_NAME["RESET_PASSWORD"] = "ResetPassword";
    E_ROUTE_NAME["SSO_USER_PROFILE"] = "SSOUserProfile";
    E_ROUTE_NAME["DING_TALK_LANDING_PAGE"] = "dingTalkLandingPage";
    E_ROUTE_NAME["WE_CHAT_LANDING_PAGE"] = "weChatLandingPage";
    E_ROUTE_NAME["FEI_SHU_LANDING_PAGE"] = "feiShuLandingPage";
    E_ROUTE_NAME["THIRD_PARTY_SSO_TRANSFER_PAGE"] = "thirdPartySSOTransferPage";
    E_ROUTE_NAME["EVENT_PROMOTION_REGISTRATION"] = "eventPromotionRegistration";
    E_ROUTE_NAME["EVENT_PROMOTION_REGISTRATION_EMBED"] = "eventPromotionRegistrationEmbed";
    E_ROUTE_NAME["UNSUBSCRIBE"] = "Unsubscribe";
    E_ROUTE_NAME["UnlockUser"] = "UnlockUser";
    E_ROUTE_NAME["Unlock"] = "Unlock";
    E_ROUTE_NAME["ResendActive"] = "ResendActive";
})(E_ROUTE_NAME || (E_ROUTE_NAME = {}));
